"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRuntime = exports.parseImmediately = exports.fetchRuntimeJson = exports.cacheDeps = exports.updateRuntimeState = exports.execute = void 0;
var sandbox_1 = require("@ice/sandbox");
var utils_1 = require("./utils");
var modules_1 = require("./modules");
/**
 * CustomEvent Polyfill for IE.
 * See https://gist.github.com/gt3/787767e8cbf0451716a189cdcb2a0d08.
 */
(function () {
    if (typeof window.CustomEvent === 'function')
        return false;
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();
var runtimeCache = {};
/**
 * excute one or multi runtime in serial.
 */
function execute(codes, deps, sandbox) {
    if (sandbox === void 0) { sandbox = new sandbox_1.default({ multiMode: true }); }
    sandbox.createProxySandbox(deps);
    utils_1.any2AnyArray(codes).forEach(function (code) { return sandbox.execScriptInSandbox(code); });
    var addedProperties = sandbox.getAddedProperties();
    sandbox.clear();
    return addedProperties;
}
exports.execute = execute;
function updateRuntimeState(mark, state) {
    if (!runtimeCache[mark]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        runtimeCache[mark] = {};
    }
    runtimeCache[mark].state = state;
}
exports.updateRuntimeState = updateRuntimeState;
/**
 * fetch, excute then cache runtime info.
 */
function cacheDeps(runtime, deps, fetch) {
    var _a, _b, _c;
    if (fetch === void 0) { fetch = window.fetch; }
    return __awaiter(this, void 0, void 0, function () {
        var id, url, mark, _d, cssList, jsList, _e, e_1;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    id = runtime.id, url = runtime.url;
                    mark = id;
                    if (!(((_a = runtimeCache[mark]) === null || _a === void 0 ? void 0 : _a.state) === 'LOADING')) return [3 /*break*/, 2];
                    // await util resource loaded or error
                    return [4 /*yield*/, new Promise(function (resolve) { return window.addEventListener(mark, resolve); })];
                case 1:
                    // await util resource loaded or error
                    _f.sent();
                    _f.label = 2;
                case 2:
                    if (((_b = runtimeCache[mark]) === null || _b === void 0 ? void 0 : _b.state) === 'LOADED') {
                        return [2 /*return*/, (_c = runtimeCache[mark]) === null || _c === void 0 ? void 0 : _c.deps];
                    }
                    updateRuntimeState(mark, 'LOADING');
                    _d = modules_1.parseUrlAssets(url), cssList = _d.cssList, jsList = _d.jsList;
                    // append css
                    Promise.all(cssList.map(function (css) { return modules_1.appendCSS("runtime-" + id, css); }));
                    _f.label = 3;
                case 3:
                    _f.trys.push([3, 5, , 6]);
                    _e = runtimeCache[mark];
                    return [4 /*yield*/, Promise.all(jsList
                            .map(function (u) { return fetch(u).then(function (res) { return res.text(); }); })).then(function (codes) { return execute(codes, deps); })];
                case 4:
                    _e.deps = _f.sent();
                    updateRuntimeState(mark, 'LOADED');
                    window.dispatchEvent(new CustomEvent(mark, { detail: { state: 'LOADED' } }));
                    return [2 /*return*/, runtimeCache[mark].deps];
                case 5:
                    e_1 = _f.sent();
                    updateRuntimeState(mark, 'LOAD_ERROR');
                    window.dispatchEvent(new CustomEvent(mark, { detail: { state: 'LOAD_ERROR' } }));
                    console.error("[icestark module] " + id + " fetch or excute js assets error", e_1);
                    return [2 /*return*/, Promise.reject(e_1)];
                case 6: return [2 /*return*/];
            }
        });
    });
}
exports.cacheDeps = cacheDeps;
function fetchRuntimeJson(url, fetch) {
    if (fetch === void 0) { fetch = window.fetch; }
    if (!/.json/.test(url)) {
        console.warn('[icestark-module] runtime url should be a json file.');
    }
    return fetch(url).then(function (res) { return res.json(); });
}
exports.fetchRuntimeJson = fetchRuntimeJson;
function parseImmediately(runtimes, fetch) {
    if (fetch === void 0) { fetch = window.fetch; }
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, runtimes.reduce(function (pre, next) { return __awaiter(_this, void 0, void 0, function () {
                        var preProps, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, pre];
                                case 1:
                                    preProps = _b.sent();
                                    _a = [__assign({}, preProps)];
                                    return [4 /*yield*/, cacheDeps(next, preProps, fetch)];
                                case 2: return [2 /*return*/, __assign.apply(void 0, _a.concat([(_b.sent())]))];
                            }
                        });
                    }); }, Promise.resolve({}))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.parseImmediately = parseImmediately;
function parseRuntime(runtime, fetch) {
    if (fetch === void 0) { fetch = window.fetch; }
    return __awaiter(this, void 0, void 0, function () {
        var runtimeConfigs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // if runtime is `undefined`/`false`
                    if (!runtime) {
                        return [2 /*return*/, null];
                    }
                    if (!(typeof runtime === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchRuntimeJson(runtime, fetch)];
                case 1:
                    runtimeConfigs = _a.sent();
                    return [2 /*return*/, parseImmediately(runtimeConfigs)];
                case 2:
                    /*
                    * runtime info provided in detail.
                     */
                    if (Array.isArray(runtime)) {
                        return [2 /*return*/, parseImmediately(runtime)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.parseRuntime = parseRuntime;
